import React from "react";
import { FooterContainer, FooterWithLink, StyledFooterText } from "./styled";

const Footer = () => {
  return (
    <FooterContainer>
      <StyledFooterText>
        Granny & Charly est un organisme du Service à la personne, qui propose
        un service gratuit d'aide pour toute personne à la recherche de la
        solution la plus adaptée pour son proche âgé. Nous vous aidons
        gratuitement à trouver en moins de 24 heures une aide à domicile
        qualifiée, bienveillante et fiable, sur laquelle vous pourrez compter.
      </StyledFooterText>
      <FooterWithLink>
        <a
          href="https://grannycharly.fr/conditions-generales-de-vente/"
          style={{ color: "black", textDecoration: "none" }}
        >
          Mentions légales{" "}
        </a>
        <a
          href="https://grannycharly.fr/politique-de-confidentialite/"
          style={{ color: "black" }}
        >
          Politique de confidentialité
        </a>
      </FooterWithLink>
    </FooterContainer>
  );
};

export default Footer;
